<template>
  <div class="common-title-page product-characteristics-page">
    <div class="title-wrapper">
      <product-input ref="productInput"></product-input>
      <span class="title">{{ $t('text.product_characteristics') }}</span>
    </div>
    <div class="mt-20"></div>
    <el-tabs
      v-model="activeHw"
      type="card"
      class="product-characteristics-tab"
      v-if="hwVersions.length"
    >
      <el-tab-pane
        :label="$t('text.hardware') + '-' + item"
        :name="item"
        v-for="item in hwVersions"
        :key="item"
      >
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activeFw" type="card" v-if="fwVersions.length">
      <el-tab-pane
        :label="'V-' + item"
        :name="item"
        v-for="item in fwVersions"
        :key="item"
      ></el-tab-pane>
    </el-tabs>
    <el-table border :data="tableData" size="small" v-loading="loading">
      <el-table-column
        :label="$t('text.position')"
        prop="position"
        :fixed="screenWidth > 767"
      >
        <template slot-scope="scope">
          {{ getPosition(scope.row.position) }}
        </template>
      </el-table-column>
      <el-table-column label="Max Sensor" prop="constantA"> </el-table-column>
      <el-table-column :label="$t('text.constant') + ' B'" prop="constantB">
      </el-table-column>
      <el-table-column :label="$t('text.constant') + ' C'" prop="constantC">
      </el-table-column>
      <el-table-column :label="$t('text.constant') + ' D'" prop="constantD">
      </el-table-column>
      <el-table-column
        :label="$t('text.yellow_threshold')"
        prop="yellowThreshold"
      >
      </el-table-column>
      <el-table-column :label="$t('text.red_threshold')" prop="redThreshold">
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.constant') + ' A'"
        prop="urineConstantA"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.constant') + ' B'"
        prop="urineConstantB"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.constant') + ' C'"
        prop="urineConstantC"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.constant') + ' D'"
        prop="urineConstantD"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.yellow_threshold')"
        prop="urineYellowThreshold"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.urine') + ' ' + $t('text.red_threshold')"
        prop="urineRedThreshold"
      >
      </el-table-column>
      <el-table-column :label="$t('text.firmware_version')" prop="fwVersion">
      </el-table-column>
      <el-table-column :label="$t('text.hardware_version')" prop="hwVersion">
      </el-table-column>
      <el-table-column :label="$t('text.max_capacity')" prop="maxCapacity">
      </el-table-column>
      <el-table-column label="Clumping Multiplier" prop="clumpingMultiplier">
      </el-table-column>
      <el-table-column label="Clumping Enabled" prop="isClumpingEnabled">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isClumpingEnabled"
            @input="enableDisableClumping(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('text.action') | firstLetterCapitalize"
        min-width="320"
        :fixed="screenWidth > 767 ? 'right' : false"
        v-if="p('Products.Product Characteristics.Edit')"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            class="save-btn mini-btn min-w-80"
            @click="edit(scope.row)"
            >{{ $t('text.view') | firstLetterCapitalize }}/{{
              $t('text.edit') | firstLetterCapitalize
            }}</el-button
          >
          <el-button
            type="success"
            plain
            class="save-btn mini-btn min-w-80"
            @click="duplicate(scope.row)"
            >Duplicate</el-button
          >
          <el-button
            type="success"
            plain
            class="delete-btn mini-btn min-w-80 ml-10"
            @click="deleteRow(scope.row)"
            >Delete</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="text-right">
      <b-button
        size="sm"
        variant="outline-success"
        class="min-w-80 mt-30"
        @click="add()"
        v-if="p('Products.Product Characteristics.Add')"
        >{{ $t('text.add') | firstLetterCapitalize }}</b-button
      >
    </div>
    <EditProductCharacteristics ref="editProductCharacteristics" />
    <DuplicateCharacteristics ref="duplicateCharacteristics" />
  </div>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import ProductInput from '@/components/ProductInput'
import EditProductCharacteristics from '@/components/products/products/EditProductCharacteristics'
import DuplicateCharacteristics from '@/components/products/products/DuplicateCharacteristics'
import swal from 'sweetalert'
export default {
  data() {
    return {
      activeHw: '',
      activeFw: '',
      screenWidth: window.innerWidth,
      loading: false,
      tableData: [],
      hwVersions: [],
      fwVersions: [],
      positions: ''
    }
  },
  components: {
    ProductInput,
    EditProductCharacteristics,
    DuplicateCharacteristics
  },
  mounted() {
    this.getHwVersions()
    this.getPositions()
  },
  watch: {
    activeHw() {
      this.getFwVersions()
      this.getData()
    },
    activeFw() {
      this.getData()
    },
    '$store.state.product.selectedProduct': function() {
      this.tableData = []
      this.hwVersions = []
      this.fwVersions = []
      this.activeHw = ''
      this.activeFw = ''
      this.getHwVersions()
    }
  },
  methods: {
    getPosition(val) {
      let str
      for (let key in this.positions) {
        if (this.positions[key] === val) {
          str = key
        }
      }
      return str
    },
    getPositions() {
      this.loading = true
      ApiService.GetPosition()
        .then(response => {
          this.loading = false
          this.positions = response.data.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    getHwVersions(updateActive = true) {
      if (!this.$store.state.product.selectedProduct) return false
      this.loading = true
      ApiService.GetProductThresholdsByProductId(
        this.$store.state.product.selectedProduct.id
      )
        .then(response => {
          this.loading = false
          let hwVersions = response.data.data.map(item => {
            return item.hwVersion
          })
          this.hwVersions = Array.from(new Set(hwVersions))
          if (
            (this.hwVersions.length && updateActive) ||
            (this.hwVersions.length && !this.activeHw)
          ) {
            this.activeHw = this.hwVersions[0]
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getFwVersions(updateActive = true) {
      if (!this.$store.state.product.selectedProduct) return false
      this.loading = true
      ApiService.GetProductThresholdsByProductId(
        this.$store.state.product.selectedProduct.id
      )
        .then(response => {
          this.loading = false
          let vm = this
          let fwVersions = response.data.data.filter(item => {
            return item.hwVersion === vm.activeHw
          })
          fwVersions = fwVersions.map(item => {
            return item.fwVersion
          })
          this.fwVersions = Array.from(new Set(fwVersions))
          if (
            (this.fwVersions.length && updateActive) ||
            (this.fwVersions.length && !this.activeFw)
          ) {
            this.activeFw = this.fwVersions[0]
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getData() {
      if (!this.$store.state.product.selectedProduct) return false
      this.loading = true
      ApiService.GetProductThresholdsByProductId(
        this.$store.state.product.selectedProduct.id
      )
        .then(response => {
          this.loading = false
          let vm = this
          this.tableData = response.data.data.filter(item => {
            return (
              item.hwVersion === vm.activeHw && item.fwVersion === vm.activeFw
            )
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editProductCharacteristics.openDialog()
    },
    edit(row) {
      this.$refs.editProductCharacteristics.openDialog()
      this.$refs.editProductCharacteristics.form = JSON.parse(
        JSON.stringify(row)
      )
    },
    duplicate(row) {
      this.$refs.duplicateCharacteristics.openDialog()
      this.$refs.duplicateCharacteristics.form.ID = row.id
    },
    deleteRow(row) {
      this.$confirm(
        'Please keep in mind that deleting records is permanent.',
        this.$t('text.you_able_to_delete_data') + ' this record',
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleDelete(row.id)
        })
        .catch(() => {})
    },
    handleDelete(id) {
      let isTheLatest = this.tableData.length <= 1
      let isLatestFw = this.fwVersions.length <= 1
      ApiService.DeleteProductThreshold(id)
        .then(response => {
          if (response.data.success) {
            //After deleting, determine whether the current tab has data, if there is data, also display the current tab, if not, vice versa
            this.getHwVersions(isTheLatest && isLatestFw)
            this.getFwVersions(isTheLatest)
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Deleted Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Deleted Failed'
          })
        })
    },
    enableDisableClumping(item) {
      ApiService.EnableDisableClumping(item.id, item.isClumpingEnabled)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Updated Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Updated Failed'
          })
        })
    }
  }
}
</script>
